import React, { FC } from 'react'
import { ChatBubbleBottomCenterTextIcon } from '@heroicons/react/20/solid'
import SvgSpinnerBlue from '@/components/icons/spinner-blue'

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean
}

const AiAssistantNewChatBtn: FC<Props> = ({
  className = 'w-full h-8 px-2 py-1 flex items-center justify-center gap-2 text-center text-white leading-4 border border-transparent rounded-md bg-v8-blue disabled:opacity-70 disabled:cursor-not-allowed disabled:pointer-events-none hover:bg-white hover:border-v8-violet hover:text-v8-blue transition ease-in-out duration-500',
  onClick,
  isLoading,
  children = (
    <>
      {isLoading ? (
        <SvgSpinnerBlue classess={'w-[18px] h-[18px]'} withyMargin={false} />
      ) : (
        <ChatBubbleBottomCenterTextIcon className="w-[18px] h-[18px] block" />
      )}
      <span className="">{'New Chat'}</span>
    </>
  ),
  ...props
}) => {
  return (
    <button onClick={onClick} className={className} {...props}>
      {children}
    </button>
  )
}

export default AiAssistantNewChatBtn
